import { Controller } from "@hotwired/stimulus"

// Cmd/Ctrl+K and the nav search icon (app/views/shared/_search_button.html.erb)
// both open the global search modal the same way. Registered on <body> in
// application.html.erb, separate from admin_search_controller.js on purpose:
// that one only exists once the modal is already open and only knows how to
// search inside it; this one lives for the whole admin/staff session and
// only knows how to decide whether it is safe to open the modal at all.
// Reusing one identifier for both jobs would mean this controller connecting
// twice, on two different elements, with two different meanings — fragile.
export default class extends Controller {
  static values = { url: String }

  handleKeydown(event) {
    if (!(event.metaKey || event.ctrlKey)) return
    if (event.key.toLowerCase() !== "k") return

    event.preventDefault()
    this.open()
  }

  // KTD13/R4: a note or document-upload modal already occupying the shared
  // `modal` turbo frame must not be silently clobbered.
  //
  // Deliberately *not* Turbo.visit(): that performs a full Drive page visit,
  // which would replace the whole page (and, since it carries no Turbo-Frame
  // header, render the plain non-modal view — see inside_modal? and
  // Admin::SearchController) instead of opening the dialog overlay R1/R2
  // describe. Setting the frame's `src` is Turbo's own public API for
  // programmatically doing what a `data-turbo-frame="modal"` link click does:
  // a frame-scoped fetch (Turbo-Frame: modal) morphed into this element in
  // place. ultimate_turbo_modal's own `advance: true` config
  // (config/initializers/ultimate_turbo_modal.rb) then pushes the address-bar
  // URL once the dialog connects — no history.pushState needed here.
  open() {
    const frame = document.getElementById("modal")
    if (!frame || frame.firstElementChild) return

    frame.src = this.urlValue
  }
}
